/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const AgentSupplierService = {
  /**
   * Get Screen data
   *
   * */
  // const x : 1;

  async getByName(name) {
    const requestScreenData = {
      url: "api/AgentSupplier",
      top: "1",
      filter: `Name eq '${name}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(code) {
    const requestScreenData = {
      url: "api/AgentSupplier",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { AgentSupplierService };
